import { createUpload } from '@wix/ambassador-genie-upload-v1-upload/http';
import { useCallback } from 'react';
import { isImage } from './mimeUtils';
export const useProcessFileAttachment = props => {
  const {
    httpClient
  } = props;
  const processFileAttachment = useCallback(async file => {
    const attachment = {
      fileName: file.name,
      mimeType: file.type
    };
    try {
      return handleFile({
        attachment,
        file,
        httpClient
      });
    } catch (error) {
      return {
        status: 'error',
        attachment
      };
    }
  }, [httpClient]);
  return processFileAttachment;
};
const handleFile = async props => {
  const {
    attachment,
    file,
    httpClient
  } = props;
  if (!httpClient) {
    return {
      status: 'error',
      attachment
    };
  }
  const {
    data: {
      upload
    }
  } = await httpClient.request(createUpload({
    upload: {
      fileName: file.name,
      mimeType: file.type
    }
  }));
  if (!(upload != null && upload.uploadUrl)) {
    return {
      status: 'error',
      attachment
    };
  }
  const {
    uploadUrl,
    id
  } = upload;
  const response = await httpClient.request({
    method: 'PUT',
    url: uploadUrl,
    data: file,
    headers: {
      'Content-Type': file.type
    }
  });
  if (response.status !== 200) {
    return {
      status: 'error',
      attachment
    };
  }
  return {
    status: 'success',
    attachment: {
      ...attachment,
      viewUrl: isImage(file) ? URL.createObjectURL(file) : undefined,
      url: 'genie-upload://' + id
    }
  };
};
//# sourceMappingURL=useProcessFileAttachment.js.map